require('./button.js');
require('./dist/page-notice/ds6/page-notice.css');
